// removed by extract-text-webpack-plugin
module.exports = {"ControlsWrapperClosed":"ControlPanel__ControlsWrapperClosed___2P-1M","ControlsWrapperOpen":"ControlPanel__ControlsWrapperOpen___3lBxQ","panelToggleBtn":"ControlPanel__panelToggleBtn___3yRYa","panelToggleImageClosed":"ControlPanel__panelToggleImageClosed___1x4Fv","panelToggleImageOpen":"ControlPanel__panelToggleImageOpen___2suD1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/ControlPanel/ControlPanel.css
// module id = 948
// module chunks = 0